const Default = ({ children }) => children;

export { Default };
